import styled from 'styled-components';
import { minBp } from 'src/lib/theme';

export const SelectorContainer = styled.div`
  margin-bottom: 24px;
  position: relative;
`;

export const SelectorLabel = styled.div`
  color: #2a2a2a;
  font-size: 16px;
  line-height: 22px;
  margin-top: 20px;
  margin-bottom: 8px;
  text-transform: uppercase;
  font-weight: 400;

  @media ${minBp('tabletLarge')} {
    font-size: 14px;
  }
`;

export const Select = styled.select`
  width: 100%;
  padding: 12px 40px 12px 16px;
  border: 1px solid #000;
  background-color: #fff;
  font-size: 14px;
  line-height: 20px;
  color: #2a2a2a;
  appearance: none;
  cursor: pointer;
  position: relative;

  &:focus {
    outline: 2px solid #000;
    outline-offset: 2px;
  }

  @media ${minBp('tabletLarge')} {
    font-size: 16px;
    padding: 14px 40px 14px 18px;
  }
`;

export const Option = styled.option`
  padding: 8px;
  font-size: 14px;
  color: #2a2a2a;
`;

export const ArrowIcon = styled.div`
  position: absolute;
  top: 50%;
  right: 16px;
  transform: translateY(-50%);
  pointer-events: none;
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 6px solid #2a2a2a;
`;
